/* EVENTS */
export const ONBOARDING_START_EVENT = 'new_camper_start'
export const ONBOARDING_NEW_AD_EVENT = 'new_camper_step_0'
export const ONBOARDING_NEXT_STEP_TYPE_EVENT = 'new_camper_step_1'
export const ONBOARDING_NEXT_STEP_PROPERTIES_EVENT = 'new_camper_step_2'
export const ONBOARDING_NEXT_STEP_LOCATION_EVENT = 'new_camper_step_3'
export const ONBOARDING_NEXT_STEP_PICTURES_EVENT = 'new_camper_step_4'
export const ONBOARDING_NEXT_STEP_PRICE_EVENT = 'new_camper_step_5'
export const ONBOARDING_END_EVENT = 'new_camper_end'

/* PARAMS */
export const ONBOARDING_NEXT_STEP_PRICE_EVENT_PARAM = 'new_camper_deposit_method'
export const ONBOARDING_NEXT_STEP_PICTURES_EVENT_PARAM = 'new_camper_nb_picture'
